import * as CategoryType from 'show-page/constants/category-type';
import * as ClipLayout from 'show-page/constants/clip-layout';
import * as ResponsiveState from 'show-page/constants/responsive-state';
import { action, computed, extendObservable, observable } from 'mobx';
import { values } from 'lodash';


class UIStore {
    @observable appPromptState = false;
    @observable clipLayout = ClipLayout.GRID;
    @observable heroHeight = 0;
    @observable heroOffset = 0;
    @observable isMounted = false;
    @observable selectedCategory = CategoryType.EPISODES;
    @observable stickyPlayerHeight = 270;
    @observable stickyPlayerOffset = 0;
    @observable stickyPlayerState = false;
    @observable viewportWidth = window.innerWidth;


    constructor(props) {
        extendObservable(this, props);
    }


    /*=======================================
    =            Computed Values            =
    =======================================*/

    @computed get isDesktopWidth() {
        return (this.viewportWidth >= ResponsiveState.DESKTOP);
    }

    @computed get isMobileWidth() {
        return (this.viewportWidth < ResponsiveState.TABLET);
    }

    @computed get isTabletWidth() {
        return (this.viewportWidth >= ResponsiveState.TABLET && this.viewportWidth < ResponsiveState.DESKTOP);
    }

     @computed get responsiveState() {
        if (this.isDesktopWidth) {
            return ResponsiveState.DESKTOP;
        } else if (this.isTabletWidth) {
            return ResponsiveState.TABLET;
        } else {
            return ResponsiveState.MOBILE;
        }
    }

    @computed get showStickyPlayer() {
        return !!(this.stickyPlayerState && this.viewportWidth >= 1280);
    }


    /*===============================
    =            Actions            =
    ===============================*/

    @action selectCategory = (category) => {
        this.selectedCategory = category || CategoryType.EPISODES;
    };

    @action setAppPromptState = (videoID) => {
        this.appPromptState = videoID || false;
    };

    @action setClipLayout = (layout) => {
        if (layout && values(ClipLayout).indexOf(layout) !== -1) {
            this.clipLayout = layout;
        }
    };

    @action setMounted = (bool) => {
        this.isMounted = !!bool;
    };

    @action setStickyPlayerOffset = (offset) => {
        this.stickyPlayerOffset = isNaN(offset) ? 0 : offset;
    };

    @action setStickyPlayerState = (state) => {
        this.stickyPlayerState = !!state;
    };

    @action setViewportWidth = (width) => {
        this.viewportWidth = width;
    };

}


export default UIStore;



/** WEBPACK FOOTER **
 ** ./src/show-page/stores/ui.js
 **/